import {
  Drawer,
  ScrollArea,
  Text,
  Title
} from '@mantine/core'

import { TicketsForm } from '@/containers/forms'
import { Order as OrderType, Site as SiteType } from '@/types'

interface Props {
  open: boolean
  siteData: SiteType
  searchQuery?: any
  order?: OrderType
  handleClose: () => void
}

export default function TicketDrawer({
  open,
  siteData,
  searchQuery,
  order,
  handleClose
}: Props) {
  return (
    <Drawer
      padding="lg"
      size="xl"
      position="right"
      title={<Title order={3}>Novo atendimento</Title>}
      opened={open}
      onClose={handleClose}>
      <Text mb="sm">
        Preencha as informações necessárias para a abertura do atendimento.
      </Text>
      <ScrollArea style={{ height: 'calc(100vh - 150px)' }} offsetScrollbars>
        <TicketsForm.Ticket
          siteData={siteData}
          searchQuery={searchQuery}
          handleClose={handleClose}
          orderData={order}
        />
      </ScrollArea>
    </Drawer>
  )
}
